import { render, staticRenderFns } from "./InvoiceSendTypes.vue?vue&type=template&id=74702c12&"
import script from "./InvoiceSendTypes.vue?vue&type=script&lang=js&"
export * from "./InvoiceSendTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports